var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.615 2.187a.62.62 0 0 0-.885 0 .62.62 0 0 0 0 .885l8.134 8.134H2.558a.629.629 0 1 0 0 1.258h17.306l-8.134 8.134a.62.62 0 0 0 0 .885.62.62 0 0 0 .885 0l9.202-9.202a.63.63 0 0 0 .183-.447.63.63 0 0 0-.183-.446z"
})));
export default SvgArrowRight;